<button class="btn menu_btn d-md-none  mb-4" id="sidebarToggle">SideBar Menu <span
    class="navbar-toggler-icon"></span></button>


<h3>
  <a routerLink="/home-page/live-aarti"> <img src="/assets/website-assets/images/you_tube_live.png"
      class="you_tube_icon"> Click to View Live Aarti </a>
</h3>
<div class="live-camera-container">
  <div class="live-camera-label">
    <span class="live-dot"></span> Live Guffa Darshan
  </div>
  <img [src]="cameraSnapshotUrl" class="live-camera-img" alt="Live Guffa Darshan">
</div>
<div class="position-sticky">
  <ul class="nav flex-column">

    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/notification"> Notifications </a> <img
        src="/assets/website-assets/images/blnk.gif" class=" blink">
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/tenders"> Tenders </a><img src="/assets/website-assets/images/blnk.gif"
        class=" blink">
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/our-institutional"> Our Institutions </a>
    </li>
    <!-- <li class="nav-item">
                  <a class="nav-link" > Havan & Mundan   </a><img src="/assets/website-assets/images/blnk.gif" class=" blink" >
                </li> -->
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/special-arrangements"> Special Arrangements </a><img
        src="/assets/website-assets/images/blnk.gif" class=" blink">
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/safety-measures"> Safety Measures </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/place-of-interest">Place of Interest </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/contact-us"> Contact Us </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/home-page/road-map"> Road Map </a>
    </li>


  </ul>
  <div class="contact_phone">
    <img src="/assets/website-assets/images/contact_icon.png" alt="Phone Icon"> <a
      href="tel:+91-7650830606"><span>+91-7650830606</span></a>
  </div>
  <!-- <div class="contact_phone">
    <img src="/assets/website-assets/images/contact_icon.png" alt="Phone Icon"> <a
      href="tel:+91-7650830606"><span class="cross_number">+91-7650830606</span></a>
  </div> -->
  <!-- <div class="blocked_msg">
        This number has been blocked. Please do not call this number. We will update you with a new number soon.
  </div> -->

</div>